import React, { useState, useEffect } from "react";

// Components
import Sidebar from "../../components/Sidebar";
import Main from "./Invoice/Main";
import Form from "./Invoice/Form";

import {
  getDataWithComp,
  getDocStatusColour,
  getAlert,
  getMaxDocNo,
} from "../../../utils/SamuiUtils";

import { getReport } from "../../../utils/ReportUtils";
import Navbar from "../../components/Modal/Navbar";

const BillOfSale = () => {
  const [mode, setMode] = useState("");
  const [dataMasterList, setDataMasterList] = useState([]);
  const [statusColours, setStatusColours] = useState([]);
  const [statusPaidColours, setStatusPaidColours] = useState([]);
  const [maxDocNo, setMaxDocNo] = useState();

  useEffect(() => {
    initialize();
  }, []);

  const initialize = async () => {
    try {
      setMode("S");
      fetchRealtime(); // เรียกใช้งาน fetchRealtime เพื่อโหลดข้อมูลเมื่อ component โหลดครั้งแรก
    } catch (error) {
      getAlert("FAILED", error.message);
    }
  };

  const fetchRealtime = async () => {
    try {
      const masterList = await getDataWithComp(
        "API_0701_SO_H",
        `ORDER BY Doc_ID DESC`
      );
      const docStatusColour = await getDocStatusColour("SO", "Doc_Status");
      const docStatusPaidColour = await getDocStatusColour(
        "SO",
        "Doc_Status_Paid"
      );

      if (masterList && masterList.length > 0) {
        const sortedData = masterList.sort((a, b) => a.Doc_Id - b.Doc_Id);
        setDataMasterList(sortedData);
      }

      if (docStatusColour && docStatusColour.length > 0) {
        setStatusColours(docStatusColour);
      }

      if (docStatusPaidColour && docStatusPaidColour.length > 0) {
        setStatusPaidColours(docStatusPaidColour);
      }
    } catch (error) {
      getAlert("FAILED", error.message);
    }
  };

  const onPageInsert = async () => {
    setMode("I");

    const masterList = await getDataWithComp(
      "API_0701_SO_H",
      `ORDER BY Doc_ID DESC`
    );

    if (Array.isArray(masterList) && masterList.length > 0) {
      const maxDocNo = getMaxDocNo(masterList, "INV");
      setMaxDocNo(maxDocNo);
    } else {
      const fallbackDocNo = getMaxDocNo([], "INV");
      setMaxDocNo(fallbackDocNo);
    }
  };

  const onRowSelected = (docNo) => {
    setMaxDocNo(docNo);
    setMode("U");
  };
  return (
    <div className="PurchaseRequest">
      <div className="wrapper">
        <Navbar />
        <div className="main-panel">
          <div className="container">
            <div className="page-inner">
              {mode === "S" ? (
                <Main
                  masterList={dataMasterList}
                  statusColours={statusColours}
                  statusPaidColours={statusPaidColours}
                  name={"ใบกำกับภาษี "}
                  onPageInsert={() => onPageInsert()}
                  onRowSelected={(docNo) => onRowSelected(docNo)}
                  getReport={getReport}
                />
              ) : (
                <Form
                  callInitialize={initialize}
                  mode={mode}
                  name={"ใบกำกับภาษี "}
                  maxDocNo={mode === "I" ? maxDocNo : maxDocNo}
                  getReport={getReport}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BillOfSale;
